import { cn } from "@app/lib/utils";
import { URLS } from "@app/shared";
import { Breadcrumb, Link, ReadMoreText } from "@design-system/components";
import { HeroSectionBG } from "@modules/shared/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { toolLocales } from "../utils";
import { HeroKeyFigures } from "./HeroKeyFigures";

export function InvestorRelationsPageHeader() {
  const currentLocale = getCurrentLocaleCode();
  const { standard } = toolLocales(currentLocale);

  return (
    <section className="relative w-full overflow-hidden bg-primary pb-12 pt-10 sm:pt-20 md:pt-[94px] lg:pb-16">
      <div className="absolute left-0 top-0 h-auto w-full">
        <HeroSectionBG />
      </div>

      <div className="relative flex min-h-max w-full flex-col items-center justify-between gap-6 sm:gap-8 lg:flex-row">
        <div
          className={cn(
            "relative z-10 flex-1",
            currentLocale === "en" ? "container-left" : "container-right",
          )}
        >
          <Breadcrumb
            items={[
              { label: "home", link: URLS.home },
              { label: "investorRelations" },
            ]}
          />

          <div className="mt-8 sm:mt-10">
            <span className="inline-flex items-center gap-2.5 rounded-full border border-white/25 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white/80 sm:text-sm">
              <span className="h-2 w-2 flex-shrink-0 rounded-full bg-bright-orange" />
              {trans("tadawulBadge")}
            </span>
          </div>

          <h1 className="mt-6 text-5xl font-bold leading-[1.05] sm:mt-8 sm:text-6xl md:text-7xl xl:text-[6rem] 2xl:text-[7rem]">
            <span className="block text-white">
              {trans("investorRelationsLine1")}
            </span>
            <span className="block text-bright-orange">
              {trans("investorRelationsLine2")}
            </span>
          </h1>
          <ReadMoreText className="max-w-3xl text-base font-light leading-relaxed text-white/90 sm:text-lg xl:text-xl rtl:mt-8">
            {`${trans("senaat")} ${trans("senaatDescription")}`}
          </ReadMoreText>

          <div className="mt-8 flex flex-wrap gap-4 pb-4 sm:mt-10">
            <Link
              to={`${URLS.investor.financialInfo}?tab=reports`}
              className="inline-flex items-center gap-2 bg-secondary px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white transition-opacity hover:opacity-90 sm:px-8 sm:py-4 sm:text-base"
            >
              {trans("viewAnnualReport")}
              <span className="ltr:inline rtl:hidden">→</span>
              <span className="ltr:hidden rtl:inline">←</span>
            </Link>
            <Link
              to={`${URLS.investor.financialInfo}?tab=statements`}
              className="inline-flex items-center border border-white/50 px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:border-white hover:bg-white/10 sm:px-8 sm:py-4 sm:text-base"
            >
              {trans("financialStatements")}
            </Link>
          </div>
        </div>
        <div className="my-auto h-fit w-full flex-1 shrink-0">
          <euroland-tool
            data-tool-name="Ticker"
            data-tool-version="chart"
            data-tool-language={standard}
          />
        </div>
      </div>

      <HeroKeyFigures />
    </section>
  );
}
